import { fromUnixTime } from 'date-fns';
import { sprintf } from 'sprintf-js';

import type { ApiISODateTimeString } from 'api/types/ApiTypedDate';
import { SearchHitApplicationStatus } from 'modules/search/components/Hit/SearchHitApplicationStatus';
import { distanceInWordsToNow } from 'utils/date';

import {
  SearchJobHitFooterContent,
  SearchJobHitFooterEarlyApplicant,
  SearchJobHitFooterHolder,
  SearchJobHitFooterPublishedTimeago,
} from './SearchJobHitFooter.styled';

type Props = {
  application:
    | {
        status: 'ACTIVE' | 'INACTIVE';
        created: ApiISODateTimeString;
      }
    | undefined;
  published: number | null;
  earlyApplicant: boolean;
};

export function SearchJobHitFooter({
  application,
  published,
  earlyApplicant,
}: Props) {
  if (application)
    return (
      <SearchJobHitFooterHolder>
        <SearchJobHitFooterContent>
          <SearchHitApplicationStatus
            status={application.status}
            created={application.created}
          />
        </SearchJobHitFooterContent>
      </SearchJobHitFooterHolder>
    );

  if (!published && !earlyApplicant) return;

  return (
    <SearchJobHitFooterHolder>
      <SearchJobHitFooterContent>
        {published && (
          <SearchJobHitFooterPublishedTimeago>
            {sprintf(getText('Posted %(postedAt)s'), {
              postedAt: distanceInWordsToNow(fromUnixTime(published)),
            })}
          </SearchJobHitFooterPublishedTimeago>
        )}

        {earlyApplicant && (
          <SearchJobHitFooterEarlyApplicant data-qa-id="search-job-hit-early-applicant-label">
            🌱 {getText('Be an early applicant')}
          </SearchJobHitFooterEarlyApplicant>
        )}
      </SearchJobHitFooterContent>
    </SearchJobHitFooterHolder>
  );
}
